import React, { useEffect, useState } from "react"
import { ICustomExpandStep, ICustomTransformStep, IDataSource, IJoinStep, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType } from "@types"
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateSource, validateStep, validateStepNameAndId } from "@utils"
import { FormSection } from "@components/FormSection/FormSection"
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput"
import { updateSource, updateStep } from "../StepConfigUtils"
import { AsyncButton, hasValue, TextArea } from "uxp/components"
import { getCustomTransformation } from "@query-engine-service"
import Icon from '@images/expand.svg'
import Copilot from '@images/copilot.svg'
import { trackAnalytics } from "../../../analytics";

export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: ICustomTransformStep = Object.assign({}, step as ICustomTransformStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    const [desc, setDesc] = useState('');

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as ICustomTransformStep)
        setErrors(errors)
        setDesc((step as ICustomTransformStep)?.description || '')
    }, [step])

    async function onValueChange(field: string, value: any, source?: boolean) {
        const _query = await handleStepFieldValueChanges(context, query, selectedStepId, field, value, source)
        onChange(_query)
    }

    const source = findSourceById(query, _step?.source)

    return <React.Fragment>

        <FormSection
            label='Source'
            error={errors?.source}
        >
            <SourceSelectorInput
                source={source}
                onChange={(newSource) => { onValueChange('source', newSource, true) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

        <FormSection
            label='Description'
            error={errors?.description}
            labelPosition="top"
        >
            <TextArea

                value={desc || ''}
                onChange={(s) => { setDesc(s) }}
            // onChange={(s) => { onValueChange('description', s) }}
            />
            <div
                title={_step.code}
                style={{
                    'display': 'flex',
                    'alignItems': 'flex-start',
                    'paddingTop': '10px',
                    'justifyContent': 'flex-end',
                }}>

                {(!_step.code || (desc != _step.description)) &&
                    <AsyncButton
                        icon={Copilot}
                        className="copilot-button"
                        onClick={async () => {
                            let r = await getCustomTransformation(context, desc);
                            trackAnalytics(context.uxpContext,'custom-expand',{message:desc,success:true});

                            onValueChange('description', desc);
                            onValueChange('code', r.code);
                            onValueChange('added', r.added || []);
                            onValueChange('removed', r.removed || []);


                        }} title="Apply" />}
            </div>
            <div className='lucy-query-editor-info'>

                Examples:
                <ul>
                    <li>Add a new row for each month and add a field called 'month' </li>
                    <li>expand the occupancy data for each room to include each hour of the day and add a field 'hour' with values from 0 to 23</li>
                </ul>
            </div>

        </FormSection>


    </React.Fragment>
}

function validate(query: IQuery, step: ICustomTransformStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source')
    if (!source.isValid) errors.source = source.error
    if (!hasValue(step.description)) errors.description = "Describe the expansion you want";
    if (!hasValue(step.code)) errors.code = 'Apply your changes to see them';
    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.CustomExpand,
    name: "Custom Expand",
    description: "Expand a row into multiple rows by applying custom logic using AI.",
    icon: Icon,
    iconStyles: { backgroundSize: '50%' },
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, source: previousSource, description: '', code: '' } as ICustomExpandStep
    }
})